<template>
  <tr>
    <th
      class="text-center"
      v-if="config.selectable"
    >
      <input
        type="checkbox"
        v-model="checked"
        @change="onCheck"
      >
    </th>
    <ms-grid-header-item
      v-for="column in columns"
      :key="column.property"
      :property="column.property"
      :current-sort="currentSort"
      :direction="direction"
      :label="column.label"
      :align="column.align"
      :sortable="column.sortable"
      :sort="column.sort"
      @onSort="onSort"
    />
    <th
      class="text-center"
      style="width: 50px"
      v-if="config.actions && config.actions.length"
    />
  </tr>
</template>

<script>
import MsGridHeaderItem from './ms-grid-header-item'

export default {
  name: 'MsGridHeader',
  components: {
    MsGridHeaderItem
  },
  props: {
    /**
     * Array of items with the following structure
     * {
     * key:'',
     * label:'',
     * sortable:'', default true
     * }
     */
    config: {
      type: Object,
      required: true
    },
    columns: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      checked: false,
      currentSort: '',
      direction: ''
    }
  },
  methods: {
    onCheck () {
      this.$emit('onCheck', this.checked)
    },
    onSort (property) {
      this.currentSort = property
      this.direction = this.direction === 'asc' ? 'desc' : 'asc'
      this.$emit('onSort', {
        property: this.currentSort,
        direction: this.direction
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/modules/grid/ms-grid-header.vue